import {Component, OnInit} from '@angular/core';
import {CustomerInterface} from '../../models/customer.interface';
import {CustomerStorageService} from '../../services/customer-storage.service';
import {Router} from '@angular/router';
import {AlertMessageInterface} from '../../../shared/models/alert-message.interface';
import {ConstsHelper} from '../../../../helpers/consts.helper';
import {GetAlertMessage} from '../../../shared/store/actions/alert-message.actions';
import {select, Store} from '@ngrx/store';
import {SaveCustomerMission} from '../../../shared/store/actions/customer-mission.actions';
import {UpdateCheckPasswordVisibility} from '../../../shared/store/actions/check-password.actions';
import {CheckPasswordInterfaceState} from '../../../shared/store/state/check-password.state';
import {CustomerInterfaceState} from '../../store/state/customer.state';
import {GetMsisdnList} from '../../../lines/store/actions/msidn-list.actions';
import {MsisdnListInterfaceState} from '../../../lines/store/state/msisdn-list.state';
import * as FileSaver from 'file-saver';
import {
    DeleteCard,
    DeleteCardSuccess,
    ECardsActions,
    GetCards,
    GetCardsSuccess
} from '../../store/actions/cards.actions';
import { CardInterface } from '../../models/card.interface';
import { Actions, ofType } from '@ngrx/effects';
import { PartnerPaymentService } from '../../../shared/services/partner-payment.service';
import { CustomerService } from '../../services/customer.service';
import { ExtranetService } from '../../../shared/services/extranet.service';
import { SupportUserInterface } from '../../../shared/models/support-user.interface';
import { GetCustomer } from '../../store/actions/customer.actions';
import moment from 'moment';
import { EPaymentMethodActions, UpdatePaymentMethodSuccess } from '../../store/actions/payment-method.actions';
import { UpdateSelectedProcedure } from '../../../shared/store/actions/selected-procedure.actions';
import { SelectedProcedureInterfaceState } from '../../../shared/store/state/selected-procedure.state';
import { environment } from '../../../../../environments/environment';
import { PaymentsService } from '../../../payments/services/payments.service';

@Component({
    selector: 'app-payment-methods-list',
    templateUrl: './payment-methods-list.component.html',
    styleUrls: ['./payment-methods-list.component.css'],
    standalone: false
})
export class PaymentMethodsListComponent implements OnInit {

    cards: Array<CardInterface>;
    customer: CustomerInterface;
    selectedMethod: string;
    chosenMethod: string;
    action: string;
    displayCBCard: boolean;
    inProgressCardCreation: boolean;
    supportUser: SupportUserInterface;
    currentMethod: string;
    selectedProcedure: string;
    constHelper = ConstsHelper;
    brand?: string;
    sepa?: Blob;

    constructor(
        private router: Router,
        private store: Store<any>,
        private customerStorage: CustomerStorageService,
        private partnerPaymentService: PartnerPaymentService,
        private actions$: Actions,
        private customerService: CustomerService,
        private extranetService: ExtranetService,
        private paymentsService: PaymentsService,
    ) {}

    ngOnInit() {
        this.actions$.pipe(ofType(EPaymentMethodActions.UpdatePaymentMethodSuccess)).subscribe((result: UpdatePaymentMethodSuccess) => {
            this.store.dispatch(new GetCustomer());
        });

        this.store.pipe(select(ConstsHelper.REDUCER_SELECTED_PROCEDURE)).subscribe((response: SelectedProcedureInterfaceState) => {
            if (response.code != null) {
                this.selectedProcedure = response.code;
            }
        });

        this.store.pipe(select(ConstsHelper.REDUCER_MSISDN_LIST)).subscribe((response: MsisdnListInterfaceState) => {
            if (response.list instanceof Array && response.list.length > 0) {
                for (const msisdn of response.list) {
                    if (msisdn.status.toLowerCase() === 'active') {
                        this.displayCBCard = true;
                    }
                }
            }
        });

        this.store.pipe(select(ConstsHelper.REDUCER_CHECK_PASSWORD)).subscribe((response: CheckPasswordInterfaceState) => {
            if (response.result !== null && response.result.page === 'payment') {
                if (response.result.isValid === true) {
                    this.executeAction(response.result.password);
                }
            }

            if (response.result !== null && response.result.visibility === true) {
                this.currentMethod = this.selectedMethod;
            } else {
                this.selectedMethod = this.currentMethod;
            }
        });

        this.store.pipe(select(ConstsHelper.REDUCER_CUSTOMER)).subscribe((result: CustomerInterfaceState) => {
            if (null != result.customer) {
                this.customer = result.customer;
            }
        });

        this.actions$.pipe(ofType(ECardsActions.DeleteCardSuccess)).subscribe((result: DeleteCardSuccess) => {
            const index = this.cards.findIndex(object => {
                if (object) {
                    return object.externalId === result.paymentMethodId;
                } else {
                    return false;
                }
            });
            this.cards.splice(index, 1);
            this.store.dispatch(
                new SaveCustomerMission(
                    {
                        step: 1,
                        routeValue: 'delete_cb',
                        supportUserId: this.supportUser ? this.supportUser.id : null
                    },
                    ConstsHelper.PROCEDURE_PAYMENT_METHOD_CHANGE,
                    'account'
                )
            );
            this.store.dispatch(new GetCustomer());
        });

        this.actions$.pipe(ofType(ECardsActions.GetCardsSuccess)).subscribe((result: GetCardsSuccess) => {
            if (null != result.payload) {
                this.selectedMethod = null;
                this.cards = [];
                this.cards.push(null);
                if (this.customer.ogoneAlias) {
                    const card = {
                        id: this.customer.ogoneAlias.id,
                        customerId: this.customer.id,
                        createdAt: Date.now().toString(),
                        externalId: this.customer.ogoneAlias.id.toString(),
                        cardExpiryDate: this.customer.ogoneAlias.cardExpiration,
                        cardNumber: this.customer.ogoneAlias.cardNumber,
                        cardTitular: this.customer.ogoneAlias.cardTitular,
                        cardType: this.customer.ogoneAlias.cardBrand,
                        isSelected: this.customer.ogoneAlias.paidBill,
                    } as CardInterface;
                    this.selectedMethod = this.customer.ogoneAlias.paidBill ? card.externalId : null;
                    this.cards.push(card);
                }
                for (const card of result.payload) {
                    this.cards.push(card);
                    if (card.isSelected && (this.customer.ogoneAlias == null || !this.customer.ogoneAlias.paidBill)) {
                        this.selectedMethod = card.externalId;
                    }
                }
                this.cards.push(null);
            }
            const localStorageBlockCreationCard = ConstsHelper.LOCAL_STORAGE_TEMPORARILY_BLOCK_CREATION_NEW_CARD + '_' + this.customer.id;
            if (localStorage.getItem(localStorageBlockCreationCard)) {
                const data = JSON.parse(localStorage.getItem(localStorageBlockCreationCard));
                if (parseInt(moment(new Date()).subtract(30, 'minute').format('YYYYMMDDHHmm'), 10) < parseInt(data.date, 10)) {
                    this.inProgressCardCreation = true;
                } else {
                    localStorage.removeItem(localStorageBlockCreationCard);
                }
            }
            if (this.selectedMethod == null && this.customer.iban) {
                this.selectedMethod = 'rib';
            } else if (this.selectedMethod == null && ['', null].indexOf(this.customer.iban) !== -1) {
                this.selectedMethod = 'cheque';
            }
            this.currentMethod = this.selectedMethod;
        });

        this.brand = environment.data.brand;
        this.cards = [];
        this.displayCBCard = false;
        this.inProgressCardCreation = false;
        this.selectedMethod = null;
        this.chosenMethod = null;
        this.action = null;
        this.sepa = null;
        this.selectedProcedure = null;
        this.customer = this.customerStorage.getCustomer();
        this.store.dispatch(new GetMsisdnList());
        this.supportUser = this.extranetService.getSupportUser();
        this.store.dispatch(new GetCards());
        this.getSepa();
    }

    downloadSepa() {
        FileSaver.saveAs(new Blob([this.sepa], {type: 'application/pdf'}), 'mandat_sepa.pdf');
    }

    deleteCard(paymentMethodId: string) {
        this.chosenMethod = paymentMethodId;
        this.action = 'delete_method';
        if (this.supportUser) {
            this.store.dispatch(new UpdateCheckPasswordVisibility({visibility: false, isValid: true, password: null, page: 'payment'}));
        } else {
            this.store.dispatch(new UpdateCheckPasswordVisibility({visibility: true, isValid: null, password: null, page: 'payment'}));
        }
    }

    goToUpdatePage(method: string) {
        this.action = 'redirect_to_update_method';
        this.chosenMethod = method;
        if (method === 'cb') {
            this.store.dispatch(new UpdateSelectedProcedure(ConstsHelper.PROCEDURE_PAYMENT_METHOD_CHANGE));
        } else if (method === 'rib') {
            this.store.dispatch(new UpdateCheckPasswordVisibility({visibility: !this.supportUser, isValid: this.supportUser ? true : null, password: null, page: 'payment'}));
        }
    }

    updateMethod(paymentMethodId: string) {
        if (paymentMethodId !== this.selectedMethod) {
            this.chosenMethod = paymentMethodId;
            this.action = 'update_method';
            if (this.supportUser) {
                this.store.dispatch(new UpdateCheckPasswordVisibility({visibility: false, isValid: true, password: null, page: 'payment'}));
            } else {
                this.store.dispatch(new UpdateCheckPasswordVisibility({visibility: true, isValid: null, password: null, page: 'payment'}));
            }
        }
    }

    executeAction(password?: string) {
        if (this.action === 'delete_method') {
            this.store.dispatch(new DeleteCard(this.chosenMethod, password));
        } else if (this.action === 'update_method') {
            this.partnerPaymentService.updateSelectedCard(this.chosenMethod, password).subscribe(
                paymentMethodResponse => {
                    this.store.dispatch(
                        new SaveCustomerMission(
                            {
                                step: 1,
                                routeValue: this.chosenMethod === 'rib' ? 'debit_pay_method' : 'cb_pay_method'
                            },
                            ConstsHelper.PROCEDURE_PAYMENT_METHOD_CHANGE,
                            'account'
                        )
                    );
                    this.selectedMethod = this.chosenMethod;
                    this.chosenMethod = null;
                    this.action = null;
                }, error => {
                    const alertMessage = {
                        message: ConstsHelper.ERROR_OCCURRED_MESSAGE,
                        code: 400
                    } as AlertMessageInterface;
                    this.store.dispatch(new GetAlertMessage(alertMessage));
                    this.chosenMethod = null;
                    this.action = null;
                }
            );
        } else if (this.action === 'redirect_to_update_method' && this.chosenMethod === 'rib') {
            this.router.navigate(['/compte/paiement/modifier/iban']);
            this.chosenMethod = null;
            this.action = null;
        }
    }

    deleteIban() {
        this.customerService.deleteIban().subscribe(
            res => {
                const alertMessage = {message: ConstsHelper.CONFIRMATION_MESSAGE_DELETE_IBAN, code: 200} as AlertMessageInterface;
                this.store.dispatch(new GetAlertMessage(alertMessage));
                this.store.dispatch(new GetCustomer());
            }
        );
    }

    formattingExpiryDate(cardExpiryDate: string) {
        if (moment(cardExpiryDate, 'YYYYMM').format('MM/YYYY') !== 'Invalid date') {
            return moment(cardExpiryDate, 'YYYYMM').format('MM/YYYY');
        }
        return cardExpiryDate;
    }

    private getSepa() {
        this.paymentsService.downloadSepa(this.customer.hashSepa).subscribe(
            response => {
                this.sepa = response;
            }
        );
    }
}
